import React, {Component} from 'react';
import {Form, message, Select, AutoComplete} from "antd";
import BaseComponent from "../../../../base/BaseComponent";

const { Option } = Select;

/**
 * 部门筛选，同时记录了手动的录入。运用场景较多
 * */
class SelectInput extends BaseComponent {
    constructor(props) {
        super(props);
        this.state = {
            allDepartmentsData:[],
            index:""
        }
    }
    componentDidMount() {
        this.allDepartments();
        this.allCustomDepartments();
    }

    value;
    listenSubmit = async ()=>{//监听提交
        if(this.state.allDepartmentsData && this.value){
            let dept = this.state.allDepartmentsData.find(dept=>dept === this.value);
            if(!dept){
                await this.addCustomDepartment();
            }
        }
    };

    render() {
        let {allDepartmentsData} = this.state;
        return (
            <Form.Item label={this.props.label} required={this.props.empty} style={{display:"flex"}}>
                 <AutoComplete
                     allowClear
                     className={"normalSelect"}
                     style={{ width: 266}}
                     defaultValue={this.props.itemValue}
                     // value={this.props.itemValue}
                     placeholder="请选择"
                     onChange={(value)=>{
                         if(value === undefined){
                             value = ''
                         }
                         this.value = value;
                         this.props.callBack && this.props.callBack(value);
                     }}
                     dataSource={allDepartmentsData}
                     filterOption={(input, option) =>
                         option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                     }
                 />
                <style>{`
                       .normalSelect .ant-select-selection--single{
                            background-color: rgba(0, 80, 179, 0.04);
                       }
                `}</style>
            </Form.Item>
        );
    }

    pushDept = (dataList)=>{
        let deptList = this.state.allDepartmentsData;
        for(let j = 0 ; dataList && j < dataList.length; j++){
            let data = dataList[j];
            let isPush = true;
            for(let i = 0 ; deptList && i < deptList.length; i++){
                let dept = deptList[i];
                if(dept === data){
                    isPush = false;
                    break;
                }
            }
            if(isPush){
                deptList.push(data);
            }
        }
        this.setState({allDepartmentsData:deptList})
    };

    //获取当前所有
    allDepartments = ()=>{
        this.request({
            url: "/cm-sites-sys/dept/getAll",
            method:"GET",
            callBack: (res) => {
                if(res){
                    this.pushDept(res.map(item=>item.name));
                }
            },
            errorCallBack: (e) => {
            },
        })
    };

    allCustomDepartments = ()=>{
        this.request({
            url: "/cm-sites-business/bd/busCustomDept/page",
            method:"post",
            contentType:"json",
            body: {
                size: -1,
                params: [{
                    key: "mainBusName",
                    opt: "eq",
                    val: this.props.type
                }]
            },
            callBack: ({data}) => {
                if(data){
                    this.pushDept(data.map(item=>item.name));
                }
                // this.setState({allDepartmentsData:res})
            },
            errorCallBack: (e) => {
            },
        })
    };

    addCustomDepartment = async ()=>{
        return new Promise((resolve, reject) => {
            this.request({
                url: "/cm-sites-business/bd/busCustomDept/add",
                method:"post",
                contentType:"json",
                body: {
                    mainBusName: this.props.type,
                    name: this.value
                },
                callBack: () => {
                    resolve();
                },
                errorCallBack: (e) => {
                },
            })
        });
    }
}

export default SelectInput;
